import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InstrumentosService {


  server_url: String;

  constructor(private httpClient: HttpClient) {

    this.server_url = "https://oroblanco-il.bolsadesantiago.com" ;
  }

  getResumenPrecios() {

    let data = {
      "nemo": "PAMPA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getResumenPrecios`, data);
  }

  getResumenPreciosIPSA() {

    let data = {
      "nemo": "SIPSA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getResumenPrecios`, data);
  }

  getPresenciaIPSA() {
    let data = {
      "nemo": "SIPSA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getPresencia`, data);
  }

  getRatioIPSA(ratio: Number){
    let data = {
      "nemo": "SIPSA",
      "ratio": ratio
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getRatio`, data);
  }

  getRentabilidadIPSA(){
    let data = {
      "nemo": "SIPSA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getRentabilidad`, data);
  }

  getResumenInstrumento() {

    let data = {
      "nemo": "PAMPA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getResumenInstrumento`, data);
  }

  getUltimasVariacionesCapital() {

    let data = {
      "nemo": "PAMPA",
      "pagina": 0,
      "tamanopag": 0
    }


    return this.httpClient.post(`/api/RV_Instrumentos/getUltimasVariacionesCapital`, data);
  }

  getIndiceIntraday() {

    let data = {
      "condividendo": "S",
      "symbol": "PAMPA"
    }

    return this.httpClient.post(`/api/RV_Indices/getIndiceIntraday`, data);
  }

  getMetaHistory() {
    let data = {
      "condividendo": "S",
      "symbol": "PAMPA",
      "period": "DI"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getMetaHistory`, data);
  }

  getUltimasTransacciones() {
    let data = {
      "nemo": "PAMPA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getUltimasTransacciones`, data);
  }

  getRatio(ratio: Number) {
    let data = {
      "nemo": "PAMPA",
      "ratio": ratio
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getRatio`, data);
  }

  getRentabilidad() {
    let data = {
      "nemo": "PAMPA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getRentabilidad`, data);
  }

  getPresencia() {
    let data = {
      "nemo": "PAMPA"
    }

    return this.httpClient.post(`/api/RV_Instrumentos/getPresencia`, data);
  }

}
